// --- src/pages/ArtifactPage.js
import React from 'react';
import { useParams } from 'react-router-dom';
import Artifact from './artifact/Artifact'; // Import Artifact directly
import { useAppContext } from './AppContext'; // Corrected import path

const ArtifactPage = () => {
  const { artifactId } = useParams();
  const { getArtifactById } = useAppContext();

  const artifactData = getArtifactById(artifactId);

  return (
    <div className="md:p-6 lg:p-8 pt-0 lg:pt-0">
      {artifactData ? (
        <Artifact key={artifactData.id} artifact={artifactData} />
      ) : (
        <div>Artifact not found</div>
      )}
    </div>
  );
};

export default ArtifactPage;